// @ts-strict-ignore
import { AfterViewInit, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { LMFormComponent } from '@form/lm-form.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMModel } from '@form/model';

@Component({
  selector:  'lm-sub-form',     // SHOULD I PUT THE BUSY INDICATOR HERE
  template:  `
      <ng-container *ngIf="alertMessage">
          <div class="notification alert lm-dialog-notification"> {{alertMessage}} </div>
      </ng-container>
    <lm-form #subform
      *ngIf="formSpec"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [initDataView]="dataView"
      [formOptions]="formOptions"
      [ngStyle]="{'height': '100%'}"
      (formDisplayed)="onFormDisplayed($event)"
    >
    </lm-form>
    `,
  providers: [ LMRouteComponentService ]
})

export class LMSubFormDialogComponent implements OnInit, AfterViewInit {
  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() dataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() parentModel: LMModel;
  @Input() alertMessage: string;

  @ViewChild(forwardRef(() => LMFormComponent)) formComponent; // : LMFormComponent;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // When dataview is set in the template, the form component
    // is not fully intitialized and model is null.
    // This causes empty form to come up in the required response dialog.
    // Moving set dataview to ngAfterViewInit solves this issue
    // Commenting it out as Vonny moved setData from _initDataView setter to formDataLoaded - 09/19/17

    // this.formComponent.initDataView = this.dataView;
  }

  onFormDisplayed(event) {
    setTimeout(() => {
      if (this.parentModel) {
        this.formComponent.model.applyState(this.parentModel);
      }
    }, 1);
  }

  public handleTransactionStatus(result: LMActionResult) {
    if (this.formComponent) {
      this.formComponent.handleTransactionStatus(result);
    }
  }

  public showBusyIndicator() {
    if (this.formComponent) {
      this.formComponent.showBusyIndicator();
    }

  }

  public hideBusyIndicator() {
    if (this.formComponent) {
      this.formComponent.hideBusyIndicator()
    }
  }
}
